import { useForm } from 'react-hook-form';
import TextField from '../Reusable/Form/TextInput';
import Button from '../Reusable/Button';

const UserLoginInfo = (props: any) => {
  const { user } = props
  const {
    register,
    formState: { errors },
  } = useForm<any>({
    defaultValues: async () => {
      // let data: any = await props?.refetch()
      return {
        ...user
      }
    }
  });
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <TextField
          label={"Email"}
          register={register("email", { disabled: true })}
          errors={errors?.email}
        />
        <TextField
          label={"Username"}
          register={register("username", { disabled: true })}
          errors={errors?.username}
        />
        <TextField
          label={"Mobile Number"}
          register={register("mobile_number", { disabled: true })}
          errors={errors?.mobile_number}
        />
      </div>
      <div className="flex justify-end w-full">
        <div className="w-[100px] mr-4">
          <Button label={"Update"} disabled={true} isLoading={false} />
        </div>
      </div>
    </>
  )
}

export default UserLoginInfo